import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "fm4-favorites";
const CHANGE_EVENT = "fm4-favorites-changed";

const readFavorites = (): string[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === "string");
  } catch {
    return [];
  }
};

const writeFavorites = (ids: string[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // 忽略浏览器存储不可用的场景
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

export function useFavorites() {
  const [favoriteIds, setFavoriteIds] = useState<string[]>([]);

  useEffect(() => {
    setFavoriteIds(readFavorites());
    const sync = () => setFavoriteIds(readFavorites());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const toggleFavorite = useCallback((episodeId: string) => {
    const current = readFavorites();
    const next = current.includes(episodeId)
      ? current.filter((id) => id !== episodeId)
      : [...current, episodeId];
    writeFavorites(next);
  }, []);

  const isFavorite = useCallback(
    (episodeId: string) => favoriteIds.includes(episodeId),
    [favoriteIds],
  );

  return { favoriteIds, isFavorite, toggleFavorite };
}